import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import api from '../../api/axios';

const MesaFormModal = ({ show, onClose, onSuccess, mesaInicial = null, planoIdActivo = 1 }) => {
  const [form, setForm] = useState({
    name: '',
    status: 'libre',
    mozo_id: '',
    comensales: '',
      plano_id: 1, // default plano


  });
  const [usuarios, setUsuarios] = useState([]);

  const business = JSON.parse(localStorage.getItem('business'));
  const businessId = business?.id;

  useEffect(() => {
    if (mesaInicial) {
      setForm({
        name: mesaInicial.name || '',
        status: mesaInicial.status || 'libre',
        mozo_id: mesaInicial.mozo_id || '',
        comensales: mesaInicial.comensales || '',
       plano_id: mesaInicial.plano_id || 1,

      });
    } else {
      resetForm();
    }
  }, [mesaInicial]);

  useEffect(() => {
    const fetchMozos = async () => {
      try {
        const res = await api.get(`/users/staff?business_id=${businessId}`);
        setUsuarios(res.data.filter(u => u.role === 'mozo'));
      } catch (err) {
        console.error('Error al obtener mozos:', err);
      }
    };
    fetchMozos();
  }, [businessId]);

  const resetForm = () => {
    setForm({ name: '', status: 'libre', mozo_id: '', comensales: '',    plano_id: planoIdActivo, // 👈 Usamos el plano activo
 });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const comensales = parseInt(form.comensales, 10) || 0;
      let shape = 'rectangle';
      if (comensales <= 2) shape = 'circle';
      else if (comensales === 4) shape = 'square';

      const mesaData = {
        name: form.name,
        status: form.status,
        mozo_id: form.mozo_id || null,
        comensales,
        shape,
        business_id: businessId,
        pos_x: 100,
        pos_y: 100,
          plano_id: form.plano_id, // agregado


      };

      if (mesaInicial?.id) {
        await api.put(`/tables/${mesaInicial.id}`, mesaData);
      } else {
        await api.post('/tables', mesaData);
      }

      onSuccess?.(); // Refresca lista
      onClose();     // Cierra modal
    } catch (err) {
      console.error('Error al guardar mesa:', err);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{mesaInicial ? 'Editar mesa' : 'Nueva mesa'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control name="name" value={form.name} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Estado</Form.Label>
            <Form.Select name="status" value={form.status} onChange={handleChange}>
              <option value="libre">Libre</option>
              <option value="ocupada">Ocupada</option>
              <option value="en_espera">En espera</option>
              <option value="abonada">Abonada</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mozo asignado</Form.Label>
            <Form.Select name="mozo_id" value={form.mozo_id} onChange={handleChange}>
              <option value="">—</option>
              {usuarios.map(m => (
                <option key={m.id} value={m.id}>{m.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comensales</Form.Label>
            <Form.Control name="comensales" value={form.comensales} onChange={handleChange} type="number" />
          </Form.Group>
          <Form.Group className="mb-3">
  <Form.Label>Plano</Form.Label>
  <Form.Select name="plano_id" value={form.plano_id} onChange={handleChange}>
    <option value={1}>Plano 1</option>
    <option value={2}>Plano 2</option>
    <option value={3}>Plano 3</option>
  </Form.Select>
</Form.Group>

          <Button type="submit" variant="success">
            {mesaInicial ? 'Actualizar' : 'Guardar'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default MesaFormModal;
